<template>
    <h2>产品中心 </h2>
    <router-view></router-view>
</template>
<script>
import Parking from './ProductChildren/Parking.vue';

export default {
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    width: 100%;
    /* height: 5000px; */
    border: 1px solid skyblue;
    /* text-align: center; */
}
</style>